import Hyperlink from "source/app/presentation/Shared/Link/Hyperlink";
import { StyleClassAuto } from "source/app/presentation/Shared/Styles/Auto/StyleClassAuto";
import styled from "styled-components";

export function GetMenuItemStyleClass() {
    return StyleClassAuto({
        color: "rgb(208, 208, 208)",
        display: "block",
        width: "100%",
        padding: "6px 8px",
        whiteSpace: "nowrap",
        borderRadius: "3px",
        transition: "background 120ms ease",
        ":hover": {
            background: "rgba(255, 255, 255, 0.08)",
        },
        ":active": {
            background: "rgba(240, 207, 99, 0.16)",
        },
    });
}

export const labelStyleClass = StyleClassAuto({
    marginLeft: "8px",
});

export const accountIconStyleClass = StyleClassAuto({
    fontSize: "18px",
    verticalAlign: "-1px",
});

export const accountChevronStyleClass = StyleClassAuto({
    fontSize: "10px",
    marginLeft: "3px",
    opacity: 0.5,
    verticalAlign: "1px",
});

export const AccountToggle = styled(Hyperlink)<{ $isOpen: boolean }>`
    .${accountIconStyleClass} {
        color: ${({ $isOpen }) => ($isOpen ? "#f0cf63" : "inherit")};
        opacity: ${({ $isOpen }) => ($isOpen ? 1 : 0.42)};
        text-shadow: ${({ $isOpen }) =>
            $isOpen ? "0 0 7px rgba(240, 207, 99, 0.72)" : "none"};
        transition: color 140ms ease, opacity 140ms ease, text-shadow 140ms ease;
    }

    &:hover .${accountIconStyleClass},
    &:focus .${accountIconStyleClass},
    &:active .${accountIconStyleClass} {
        color: #f0cf63;
        opacity: 1;
        text-shadow: 0 0 7px rgba(240, 207, 99, 0.72);
    }
`;

export const compactRowStyleClass = StyleClassAuto({
    color: "rgb(208, 208, 208)",
    display: "block",
    padding: "5px 8px",
    whiteSpace: "nowrap",
    borderRadius: "3px",
    transition: "background 120ms ease",
    ":hover": {
        background: "rgba(255, 255, 255, 0.08)",
    },
    ":active": {
        background: "rgba(240, 207, 99, 0.16)",
    },
});

export const dateOffsetButtonStyleClass = StyleClassAuto({
    color: "rgb(208, 208, 208)",
    display: "inline-block",
    fontSize: "12px",
    lineHeight: "18px",
});

export const dateOffsetStepperStyleClass = StyleClassAuto({
    float: "right",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: "7px",
    minWidth: "56px",
    padding: "0 5px",
    border: "1px solid rgba(208, 208, 208, 0.24)",
    borderRadius: "3px",
    background: "rgba(0, 0, 0, 0.22)",
    lineHeight: "20px",
});

export const Container = styled.span`
    position: relative;
    display: inline-block;
    padding: 5px;
    transform: translateY(-6px);
    z-index: 30000;
`;

export const GetDropDownContentStyleClass = (show: boolean) =>
    StyleClassAuto({
        display: show ? "flex" : "none",
        flexDirection: "column",
        position: "absolute",
        minWidth: "310px",
        boxShadow: "0px 8px 16px 0px rgba(0, 0, 0, 0.2)",
        padding: "6px",
        fontSize: "18px",
        lineHeight: "24px",
        textAlign: "left",
        zIndex: 30000,
        pointerEvents: "auto",
        right: 0,
        background: "rgba(46, 46, 46, 0.94)",
        border: "1px solid rgba(255, 255, 255, 0.12)",
        borderRadius: "4px",
    });
